module.exports = __webpack_public_path__ + "static/media/mvp-apti-news.4d7e4a04.jpg";